"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = EquipmentList;
var _react = _interopRequireWildcard(require("react"));
var _commonOptionCard = require("@mmc/common-option-card");
var _commonI18n = require("@mmc/common-i18n");
var _clsx = _interopRequireDefault(require("clsx"));
var _equipmentList = _interopRequireDefault(require("./equipment-list.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function EquipmentList(_ref) {
  var _ref$equipmentList = _ref.equipmentList,
    equipmentList = _ref$equipmentList === void 0 ? [] : _ref$equipmentList,
    theme = _ref.theme,
    _ref$onEquipmentOptio = _ref.onEquipmentOptionSelected,
    onEquipmentOptionSelected = _ref$onEquipmentOptio === void 0 ? function () {
      return null;
    } : _ref$onEquipmentOptio,
    priceDisclaimerId = _ref.priceDisclaimerId,
    disclaimerData = _ref.disclaimerData,
    addPriceDisclaimer = _ref.addPriceDisclaimer,
    selectedModelCodeDefault = _ref.selectedModelCode;
  var _useState = (0, _react.useState)(selectedModelCodeDefault),
    selectedModelCode = _useState[0],
    setSelectedModelCode = _useState[1];
  var updateSelectedOption = function updateSelectedOption(_selectedModelCode) {
    setSelectedModelCode(_selectedModelCode);
    onEquipmentOptionSelected(_selectedModelCode);
  };
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: _equipmentList["default"].wrapper
  }, equipmentList.map(function (equipment) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: equipment.code + Math.random(),
      className: (0, _clsx["default"])(_equipmentList["default"].equipment)
    }, /*#__PURE__*/_react["default"].createElement(_commonOptionCard.CommonOptionCard, {
      theme: theme,
      onChange: function onChange() {
        return updateSelectedOption(equipment.code);
      },
      name: "additional-equipment-selector",
      id: equipment.id,
      value: equipment.code,
      label: equipment.title,
      fullTap: true,
      isSelected: selectedModelCode === equipment.code,
      type: "radio"
    }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      format: "price",
      options: {
        value: equipment.price.value,
        displayValue: 'MSRP ###,###.##',
        currency: 'USD',
        locale: 'en-US'
      },
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData,
      returnZero: true
    }), /*#__PURE__*/_react["default"].createElement("ul", {
      className: (0, _clsx["default"])(_equipmentList["default"].features)
    }, !!equipment.features.length && equipment.features.map(function (feature) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: feature.title + Math.random(),
        className: (0, _clsx["default"])(_equipmentList["default"].featureWrapper)
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _clsx["default"])(_equipmentList["default"].featureTitle, theme.headingSix)
      }, feature.title), !!feature.items.length && /*#__PURE__*/_react["default"].createElement("ul", null, feature.items.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: item + Math.random(),
          className: (0, _clsx["default"])(_equipmentList["default"].featureItem, theme.smallType)
        }, item);
      })));
    }))));
  }));
}